import React, { useContext } from 'react'
import './titleVideo.scss'
import dynamic from 'next/dynamic'
const BackgroundVideo = dynamic(() => import('../elements/backgroundVideo'), { ssr: false, loading: () => null })
import GlobalContext from '../../global'

export default function TitleVideo({ vimeo_video, video_desktop, video_mobile, height, loop }) {
  const global = useContext(GlobalContext)
  const video = vimeo_video
  if (vimeo_video && vimeo_video.embed_url) {
    return (
      <div className={`title-video ${height}`}>
        <BackgroundVideo video={video} />
      </div>
    )
  }
  if (global.mobile) {
    return (
      <div className={`title-video ${height}`}>
        <BackgroundVideo video={{ embed_url: video_mobile.url, width: 16, height: 9 }} loop={!(loop === 'false')} />
      </div>
    )
  }
  return (
    <div className={`title-video ${height}`}>
      <BackgroundVideo video={{ embed_url: video_desktop.url, width: 16, height: 9 }} loop={!(loop === 'false')} />
    </div>
  )
}
